import ThingSpeakSource from './ThingSpeakSource';

export default ThingSpeakSource;



// WEBPACK FOOTER //
// ./src/models/source/thingSpeak/index.js